import { Icon } from "@iconify/react";
import { Trans } from "react-i18next";

import { ProjectData } from "../sidebar/project";

import Postit from "../../../components/Postit";
import OldImage from "../../../components/OldImage";
import Skills from "../../../components/Skills";
import TextLink from "../../../components/TextLink";

export const VerificationCertificate = (): ProjectData => {
  return {
    title:
      "Blockchain Application in Online Certificate Issuance and Verification Certificate System",
    description:
      "Blockchain technology is emerging as a crucial solution for enhancing transparency and security in the management and verification of educational credentials...",
    thumbnail: "/images/verificationcertificate/thumnail.png",
    date: "Aug 2025",

    information: [
      <Postit className={"md:col-span-2"} key="intro">
        <Trans
          i18nKey="intro.part1"
          ns="verificationcertificate"
          components={{
            b: <b />,
            i: <i />,
            link: (
              <TextLink href={"https://link.springer.com/"}>Springer</TextLink>
            ),
          }}
        />
        <br />
        <br />
        <Trans
          i18nKey="intro.part2"
          ns="verificationcertificate"
          components={{
            b: <b />,
          }}
        />
      </Postit>,

      <OldImage
        key="achieve"
        src={"/images/verificationcertificate/achieve.png"}
        alt={"Achievement"}
        className={"md:col-span-1"}
      />,

      <OldImage
        key="paper"
        src={"/images/verificationcertificate/paper.png"}
        alt={"Paper"}
        className={"md:col-span-2 md:row-span-2"}
      />,

      <Postit key="role">
        <b>
          <Trans i18nKey="role.title" ns="verificationcertificate" />
        </b>
        <ul className="list-disc ml-5 mt-2">
          <Trans
            i18nKey="role.items"
            ns="verificationcertificate"
            components={{
              li: <li />,
            }}
          />
        </ul>
      </Postit>,

      <Skills
        key="skills"
        skills={[
          "Blockchain",
          "Smart Contracts",
          "Ethereum",
          "Digital Certificates",
          "Cryptography",
          "Data Encryption",
          "Academic Fraud Prevention",
        ]}
        className={"md:col-span-1"}
      />,

      <Postit key="contribution" className={"col-span-full"}>
        <b>
          <Trans i18nKey="contribution.title" ns="verificationcertificate" />
        </b>
        <ul className="list-disc ml-5 mt-2">
          <Trans
            i18nKey="contribution.items"
            ns="verificationcertificate"
            components={{
              li: <li />,
            }}
          />
        </ul>
      </Postit>,

      <OldImage
        key="published"
        src={"/images/verificationcertificate/published.png"}
        alt={"Published"}
        className={"md:col-span-2 mt-5"}
      />,

      <Postit key="publish">
        <b>
          <Trans i18nKey="publication.title" ns="verificationcertificate" />
        </b>
        <ul className="list-disc ml-5">
          <li>
            <Trans i18nKey="publication.items.0" ns="verificationcertificate" />
          </li>
          <li>
            <Trans i18nKey="publication.items.1" ns="verificationcertificate" />
          </li>
          <li>
            <Trans i18nKey="publication.items.2" ns="verificationcertificate" />
          </li>
          <TextLink href={"https://doi.org/10.1007/978-3-032-01472-6_5"}>
            <li>
              <Trans
                i18nKey="publication.items.3"
                ns="verificationcertificate"
              />
            </li>
          </TextLink>
        </ul>
      </Postit>,

      <div
        key="links"
        className={
          "col-span-full mt-6 flex flex-col sm:flex-row gap-4 justify-center items-center text-sm sm:text-base"
        }
      >
        <TextLink
          href={"https://doi.org/10.1007/978-3-032-01472-6_5"}
          className={"flex items-center gap-2 text-gray-600 font-medium"}
        >
          <Icon icon={"openmoji:link"} width={22} height={22} />
          Paper Link
        </TextLink>
      </div>,
    ],
  };
};
